const LoadingOverlay = ({ label = 'Loading…' }) => (
  <div className="absolute inset-0 z-20 flex items-start justify-center pt-10 pointer-events-none">
    <span className="flex items-center gap-2 px-3 py-2 rounded-full bg-[#f9fafa] border border-[#dfe4ed] shadow-[0px_0px_8px_1px_rgba(22,28,39,0.15)]">
      <span className="w-4 h-4 rounded-full border-2 border-[#dfe4ed] border-t-[#006c4d] animate-spin shrink-0" />
      <span className="text-sm font-medium text-[#616a79] whitespace-nowrap">{label}</span>
    </span>
  </div>
)

export default LoadingOverlay
